/*eslint-disable*/
import React from "react";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import store from "store";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  RadioGroup,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  Select,
  Typography,
  TextField
} from "@material-ui/core";
import Dropzone from "react-dropzone";
import { GetUserKey } from "helpers/UserHelper";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { fileUploadServerPath } from "constants.js";
import { createUploadLink } from "apollo-upload-client/lib/main";
import { GetUserId } from "helpers/UserHelper";

const client = new ApolloClient({
  link: createUploadLink({ uri: fileUploadServerPath }),
  cache: new InMemoryCache()
});

export const ImportClients = gql`
  mutation importClients($input: ImportClientsInput!) {
    ImportClients(input: $input) {
      clientMutationId
    }
  }
`;

const uploadCsvMutation = gql`
  mutation($file: Upload!, $id: String!) {
    uploadClientsCsvWithId(file: $file, id: $id)
  }
`;

// "Avalon", "XPlan", "Sanfin", "Momentum"

const crmOptions = ["Atwork", "Other"];
const csOptions = ["Own", "Shared"];

class ClientImportModal extends React.PureComponent {
  state = {
    importClientStatus: "Own",
    selectedImportComp: "Atwork",
    openDropzone: false,
    popoverText: "",
    dialogTitle: "",
    popoverOpen: false,
    newCompImp: null
  };

  changeImportProvider = event => {
    this.setState({ selectedImportComp: event.target.value });
  };

  changeImportStatus = event => {
    this.setState({
      importClientStatus:
        this.props.userType === "3" ? event.target.value : "Own"
    });
  };

  handleOtherCompany = event => {
    this.setState({ newCompImp: event.target.value });
    console.log(this.state.newCompImp);
  };

  closeDialog = () => {
    this.props.closeDialog(false);
  };

  importSuccess = () => {
    this.props.loadingSnack(true, "Importing Clients...");
    this.props.doneImporting();
  };

  render() {
    return (
      <Mutation
        mutation={ImportClients}
        onCompleted={data => {
          this.importSuccess();
          this.props.loadingSnack(false, "");
        }}
      >
        {mutateClients => (
          <Mutation
            client={client}
            mutation={uploadCsvMutation}
            onCompleted={data => {
              this.setState({});
              this.props.closeDialog(true);
              this.props.loadingSnack(true, "Importing Clients...");
              mutateClients({
                variables: {
                  input: {
                    csvPath: data.uploadClientsCsvWithId,
                    brokerId: GetUserId(),
                    clientStatus: this.state.importClientStatus,
                    userType: GetUserKey("userType"),
                    importCompany: this.state.importClientStatus
                  }
                }
              });
            }}
          >
            {mutate => (
              <React.Fragment>
                <Dialog
                  open={this.props.open}
                  onClose={() => this.closeDialog()}
                  className="importDialog"
                >
                  <DialogTitle>{"Importing Clients"}</DialogTitle>
                  <DialogContent>
                    <Typography variant="subheading">
                      {"Import Company :"}
                    </Typography>
                    <Grid container>
                      <Grid item  xs={12} sm={6} md={4}>
                        <Select
                          style={{ position: "relative", top: "17px" }}
                          name="CompanyImport"
                          value={this.state.selectedImportComp}
                          onChange={this.changeImportProvider}
                        >
                          {crmOptions.map(option => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item xs={12} sm={6} md={8}>
                        {this.state.selectedImportComp === "Other" && (
                          // <TextField
                          //   label={"Company Name"}
                          //   placeholder={"Other"}
                          //   onChange={(event) => this.handleOtherCompany(event)}
                          // />
                          <p>
                            Please send us an email with the CSV file you want to import with the company name from who the CSV file is from, and we will add it to our list of Import Companies.
                            info@availsoft.co.za
                          </p>
                        )}
                      </Grid>
                    </Grid>
                    {GetUserKey("userType") === "3" ? (
                      <React.Fragment>
                        <Divider style={{ marginTop: "27px" }}/>
                        <Typography
                          variant="subheading"
                          style={{ marginTop: "10px" }}
                        >
                          {"Status of Clients being Imported :"}
                        </Typography>
                        <RadioGroup
                          name="importStatus"
                          value={this.state.importClientStatus}
                          onChange={this.changeImportStatus}
                        >
                          {csOptions.map(option => (
                            <FormControlLabel
                              value={option}
                              key={option}
                              control={<Radio />}
                              label={option}
                            />
                          ))}
                        </RadioGroup>
                      </React.Fragment>
                    ) : null}
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => this.closeDialog()} color="primary">
                      Cancel
                    </Button>
                    <Dropzone
                      style={{
                        width: "fit-content",
                        height: "fit-content",
                        border: "none"
                      }}
                      onDrop={([file]) => {
                        mutate({
                          variables: {
                            file,
                            id: store.getState().login.userID
                          }
                        });
                      }}
                    >
                    {this.state.selectedImportComp === "Other" ? null : (<Button color="primary">Import</Button>)}
                      
                    </Dropzone>
                  </DialogActions>
                </Dialog>
              </React.Fragment>
            )}
          </Mutation>
        )}
      </Mutation>
    );
  }
}

export default ClientImportModal;



// WEBPACK FOOTER //
// ./src/views/Clients/components/ClientImportModal.jsx